/**
 * Utms Class.
 *
 * Abstracts parsing of utm attributes from parsed url parameters.
 *
 */

import { ParsedUrlParams } from "./urlparams";

/**
 * Utms Class.
 */
export class Utms {
        
    protected params: ParsedUrlParams;

    constructor(params: ParsedUrlParams) {
        this.params = params;
    }

    public getFirst(key: string) : string | null
    {
        if (typeof(this.params[key]) === 'undefined') {
            return null;
        }
        if (typeof(this.params[key][0]) === 'undefined') {
            return null;
        }
        return String(this.params[key][0]).trim();
    }

    public getMedium() : string | null
    {
        return this.getFirst('utm_medium');
    }

    public getSource() : string | null
    {
        return this.getFirst('utm_source');
    }

}
